/* React hooks */
import {useEffect} from "react";
/* Helpers */
import { activitiesOrder } from "../../../helper/orders";
/* Components */
import Dashboard from "../../../components/common/dashboard/Dashboard";
import Header from "../../../components/common/Header";
import Icon from "../../../components/common/Icon";
import {getActivityList} from "../../../api/admin/activityReq";
import useAuth from "../../../hooks/useAuth";
import useData from "../../../hooks/useData";
import usePager from "../../../hooks/usePager";
import {Link} from "react-router-dom";


export default function Activities() {
    const sources = "fa fa-list";
    const { activityList, setActivityList } = useData();
    const { auth } = useAuth();
    const { setTotalPages } = usePager();
    const token = auth.token;

    const activitiesApi = async () => {
        const response = await getActivityList(token)
        setActivityList(response)
    };


    useEffect(() => {
        if (activityList?.length < 1) {
            activitiesApi()
            setTotalPages(1)
        }
    }, [ activityList ]);


    return (
        <main className="admin">
            <Header
                parent="Administration"
                location="Activités"
                slug="/admin/accueil"
            />
            <div className="content-container activities-page">
                <Icon source={ sources } color="blue" span="Liste des activités"/>
                <div className="cms-button dashboard-add-button">
                    <Link id="0" to="/admin/activites/0/modifier">
                        <button className="add-button"><i className="fa fa-plus"></i><span>Ajouter une activité</span>
                        </button>
                    </Link>
                </div>
                <div className="dashboard">
                    <Dashboard activitiesApi={activitiesApi} location="Activités" dataObject={ activityList || []} order={ activitiesOrder } />
                </div>
            </div>
        </main>
    )
}